import './Progress.scss';
import { IonAccordionGroup } from '@ionic/react';
import Title from 'components/Title/Title';
import Layout from 'components/Layout/Layout';
import AccordionItem from 'components/AccordionItem/AccordionItem';
import ProgressListItem from 'components/ProgressListItem/ProgressListItem';
import {useMyProgress} from "../../hooks/useMyProgress";
import PlaceholderCardBox from "../../components/CardBox/Placeholder";
import {IActivityCategory, ICategoryActivity} from "../../models";
import {useFooter} from "../../hooks";
import {documentToHtmlString} from "@contentful/rich-text-html-renderer";



const Progress: React.FC = () => {
    const { data, isLoading, isError } = useMyProgress();
    const { data: dataFooter } = useFooter('myProgressFooter');

    if (isError) return null;

    const footer = documentToHtmlString(dataFooter?.footer);
  return (
    <Layout copyright={footer}>
      <div className="Progress-page">
        <Title text="My progress" />

        <IonAccordionGroup className="mt-8">
          { isLoading || !data? (
              <PlaceholderCardBox />
          ): (
              data.activities?.map((item: IActivityCategory, i) => {
                  const complete = !!item.categoryActivities?.length &&
                      item.categoryActivities.every((a) => a.isCompleted);
                  return (
                      <AccordionItem
                          key={i}
                          title={item.title}
                          complete={complete}>
                        {item.categoryActivities?.map((item: ICategoryActivity, i: number) => (
                            <ProgressListItem key={i} title={item.title} isComplete={item.isCompleted}/>
                        ))}
                      </AccordionItem>
                  );
              })
          )}
        </IonAccordionGroup>
      </div>
    </Layout>
  );
};

export default Progress;
